module.exports = __webpack_public_path__ + "img/1f918-1f3ff.59af9be.svg";